export interface ErrorItem {
  errorCode: number;
  errorMessage: string;
  errorData: any;
}

export interface ApiError {
  generalReason?: string;
  errors: ErrorItem[];
}

export class ApplicationError extends Error {
  applicationStatus?: number;
  handled: boolean;

  constructor(message?: string) {

    super(message);
    this.name = ApplicationError.name;
    Object.setPrototypeOf(this, ApplicationError.prototype);

  }
}

export class SilentError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = SilentError.name;
    Object.setPrototypeOf(this, SilentError.prototype);
  }
}
